import http from './_http'

/**
 * 获取我的页面数据
 * @param params
 * @param meta
 * @returns {Promise | Promise<unknown>}
 */
export const infoMy = (params = {}, meta = {}) => {
    return http({
        url: '/info/my',
        method: 'get',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
            ...meta
        }
    });
}

/**
 * 更新服务价格
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoUpdateCategoryPrice = (params = {}) => {
    return http({
        url: '/info/update_category_price',
        method: 'post',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true
        }
    });
}


/**
 * 更新头像
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoUpdateIcon = (params = {}) => {
    return http({
        url: '/info/update_icon',
        method: 'post',
        params,
        meta: {
            login: true
        },
    });
}

/**
 * 取消审核头像
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoCancelIcon = (params = {}) => {
    return http({
        url: '/info/cancel_icon',
        method: 'post',
        params,
        meta: {
            login: true
        },
    });
}

/**
 * 更新昵称
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoUpdateName = (params = {}) => {
    return http({
        url: '/info/update_name',
        method: 'post',
        params,
        meta: {
            login: true
        },
    });
}

/**
 * 助理详情页 编辑tab 数据源
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoData = (params = {}) => {
    return http({
        url: '/info/data',
        method: 'get',
        params,
        meta: {
            login: true
        },
    });
}

/**
 * 助理详情页 更新基础数据
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoUpdateInfo = (params = {}) => {
    return http({
        url: '/info/update_info',
        method: 'post',
        params,
        meta: {
            login: true
        },
    });
}

/**
 * 助理更新服务城市
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoUpdateWaiterCity = (params = {}) => {
    return http({
        url: '/info/update_waiter_city',
        method: 'post',
        params,
        meta: {
            login: true
        },
    });
}

/**
 * 助理更新手机号
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoUpdateContactMobile = (params = {}) => {
    return http({
        url: '/info/update_contact_mobile',
        method: 'post',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        },
    });
}

/**
 * 助理详情页 更新视频
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoUpdateSimpleVideo = (params = {}) => {
    return http({
        url: '/info/update_simple_video',
        method: 'post',
        params,
        meta: {
            login: true
        },
    });
}

/**
 * 助理详情页 更新标签
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoUpdateTag = (params = {}) => {
    return http({
        url: '/info/update_tag',
        method: 'post',
        params,
        meta: {
            login: true
        },
    });
}

/**
 * 助理详情页 取消审核美颜视频
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoCancelSimpleVideo = (params = {}) => {
    return http({
        url: '/info/cancel_simple_video',
        method: 'post',
        params,
        meta: {
            login: true
        },
    });
}

/**
 * 获取服务信息
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const infoWaiterData = (params = {}) => {
    return http({
        url: '/info/waiter_data',
        method: 'get',
        params,
        meta: {
            toast: true,
            loading: true,
            login: true
        },
    });
}

/**
 * 编辑是否接单
 * @returns {Promise | Promise<unknown>}
 * @param openFlag
 */
export const infoUpdateOpenFlag = (openFlag) => {
    return http({
        url: '/info/update_open_flag',
        method: 'post',
        params: { openFlag },
        meta: {
            toast: true,
            loading: true,
            loadingText: '切换中',
            login: true
        },
    });
}


/**
 * 全局红点
 * @param params
 * @param headers
 * @returns {Promise | Promise<unknown>}
 */
export const infoRedDot = (params = {}, headers = {}) => {
    return http({
        url: '/info/reddot',
        method: 'get',
        params,
        headers,
        meta: {
            unAutoLogin: true,
        }
    });
}
